export const getFinalPrice = ({ bundleMeta, selectedOptions, options }) => {
  if (!bundleMeta?.price) {
    return 0;
  }
  const {
    max_discount_percent = 0,
    original_price,
    discount_percent = 0,
  } = bundleMeta.price;
  const discountPercent = parseInt(discount_percent, 10);
  let price = parseInt(original_price, 10);
  const maxDiscountPercent = parseInt(max_discount_percent, 10);
  Object.keys(selectedOptions).forEach(optionId => {
    const optionToCheck = options.find(
      opt => parseInt(opt.id, 10) === parseInt(optionId, 10)
    );
    const optionValueId = selectedOptions[optionId];
    const optionValue = (optionToCheck?.values || []).find(
      opt => parseInt(opt.id, 10) === parseInt(optionValueId, 10)
    );
    if (optionValue) {
      const { additional_cost = 0 } = optionValue;
      price += additional_cost;
    }
  });

  const priceWithOptionsPrice = price;
  let priceAfterDiscount = priceWithOptionsPrice;
  if (discount_percent) {
    priceAfterDiscount = Math.round(
      (priceWithOptionsPrice * (100 - discountPercent)) / 100
    );
  }
  if (max_discount_percent || maxDiscountPercent) {
    Math.round((priceWithOptionsPrice * (100 - maxDiscountPercent)) / 100);
  }

  return { price: priceAfterDiscount, original_price, discount_percent };
};

const getSimpleSelectedOptionsArray = selectedOptions =>
  Object.keys(selectedOptions).map(option_id => ({
    option_id: parseInt(option_id, 10),
    option_value_id: selectedOptions[option_id],
  }));

export const getProductOptionsForAddToCart = ({
  selectedOptions,
  options = null,
  addlProdOption = null,
}) => {
  let productOptions = getSimpleSelectedOptionsArray(selectedOptions);

  // remove from options if extra options which dont belong to the product are present
  if (options) {
    productOptions = productOptions.filter(
      po =>
        !!options.find(
          opt => parseInt(opt.id, 10) === parseInt(po.option_id, 10)
        )
    );
  }
  // for those who have different orientation .change that in the product options to reflect that.
  if (addlProdOption) {
    const filteredArray = productOptions.filter(
      opt => opt.option_id !== addlProdOption.option_id
    );
    filteredArray.push(addlProdOption);
    productOptions = filteredArray;
  }
  return { productOptions };
};
